import { render, staticRenderFns } from "./ShoplistStaticDumplings.vue?vue&type=template&id=cc364890&"
import script from "./ShoplistStaticDumplings.vue?vue&type=script&lang=js&"
export * from "./ShoplistStaticDumplings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc364890')) {
      api.createRecord('cc364890', component.options)
    } else {
      api.reload('cc364890', component.options)
    }
    module.hot.accept("./ShoplistStaticDumplings.vue?vue&type=template&id=cc364890&", function () {
      api.rerender('cc364890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/ShoplistStaticDumplings.vue"
export default component.exports